var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _vm.avatar
        ? [
            _c("img", {
              staticClass: "h-5 w-5 mr-1 rounded-full",
              attrs: { src: _vm.filepath, alt: "" },
            }),
          ]
        : [
            _c(
              "svg",
              {
                staticClass:
                  "border border-gray-300 h-5 w-5 mr-1 rounded-full text-gray-300",
                attrs: { fill: "currentColor", viewBox: "0 0 24 24" },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z",
                  },
                }),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }